/* LM - Fiche produit : variantes, galerie, visionneuse. */
(function () {
  'use strict';

  var root = document.getElementById('lmfp');
  if (!root) { return; }

  var dataEl = document.getElementById('lmfp-data');
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var colIdx = data.colPos > 0 ? data.colPos - 1 : -1;
  var sizeIdx = data.sizePos > 0 ? data.sizePos - 1 : -1;

  var gal = document.getElementById('lmfp-gal');
  var dots = document.getElementById('lmfp-dots');
  var count = document.getElementById('lmfp-count');
  var priceEl = document.getElementById('lmfp-price');
  var wasEl = document.getElementById('lmfp-was');
  var colName = document.getElementById('lmfp-colname');
  var addBtn = document.getElementById('lmfp-add');
  var errEl = document.getElementById('lmfp-err');
  var thirdEl = document.getElementById('lmfp-third');
  var sgEl = document.getElementById('lmfp-sg');
  var vidEl = document.getElementById('lmfp-vid');
  var accel = document.getElementById('lmfp-accel');
  var addLabel = addBtn ? addBtn.textContent : '';

  var state = [];
  var first = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
  if (first) { state = first.opts.slice(); }

  var params = new URLSearchParams(location.search);
  var wanted = params.get('variant');
  if (wanted) {
    var w = data.variants.filter(function (v) { return String(v.id) === String(wanted); })[0];
    if (w) { state = w.opts.slice(); }
  }

  function isMobile() { return window.matchMedia('(max-width:749px)').matches; }

  function match() {
    return data.variants.filter(function (v) {
      for (var i = 0; i < state.length; i++) {
        if (state[i] !== null && state[i] !== undefined && v.opts[i] !== state[i]) { return false; }
      }
      return true;
    })[0] || null;
  }

  function sizeAvailable(val) {
    return data.variants.some(function (v) {
      if (v.opts[sizeIdx] !== val) { return false; }
      if (colIdx > -1 && v.opts[colIdx] !== state[colIdx]) { return false; }
      return v.available;
    });
  }

  function paint() {
    if (colIdx > -1) {
      root.querySelectorAll('[data-lmfp-col]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-lmfp-col') === state[colIdx] ? 'true' : 'false');
      });
      if (colName) { colName.textContent = state[colIdx] || ''; }
    }
    if (sizeIdx > -1) {
      root.querySelectorAll('[data-lmfp-size]').forEach(function (b) {
        var val = b.getAttribute('data-lmfp-size');
        b.setAttribute('data-sold', sizeAvailable(val) ? '0' : '1');
        b.setAttribute('aria-pressed', val === state[sizeIdx] ? 'true' : 'false');
      });
    }
    var v = match();
    if (accel) {
      var lock = (sizeIdx > -1 && !state[sizeIdx]) || !v || !v.available;
      accel.classList.toggle('is-locked', lock);
    }
    if (v) {
      if (vidEl) { vidEl.value = v.id; }
      if (priceEl) { priceEl.innerHTML = v.price; }
      if (thirdEl) { thirdEl.innerHTML = v.third || ''; }
      if (wasEl) { wasEl.innerHTML = v.compare || ''; wasEl.style.display = v.compare ? '' : 'none'; }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addLabel : 'Épuisé';
      }
      try {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      } catch (e) {}
    } else if (addBtn) {
      addBtn.disabled = false;
      addBtn.textContent = addLabel;
    }
  }

  function slideTo(i) {
    var el = root.querySelector('[data-lmfp-slide="' + i + '"]');
    if (!el) { return; }
    if (isMobile()) {
      var left = i * gal.clientWidth;
      gal.scrollTo({ left: left, behavior: 'smooth' });
      setTimeout(function () {
        if (Math.abs(gal.scrollLeft - left) > 4) { gal.scrollLeft = left; }
        onScroll();
      }, 320);
    } else {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-lmfp-col]');
    if (c) {
      state[colIdx] = c.getAttribute('data-lmfp-col');
      if (sizeIdx > -1 && state[sizeIdx] && !sizeAvailable(state[sizeIdx])) { state[sizeIdx] = null; }
      paint();
      var to = parseInt(c.getAttribute('data-lmfp-slide-to'), 10);
      if (!isNaN(to)) { slideTo(to); }
      return;
    }
    var s = e.target.closest('[data-lmfp-size]');
    if (s) {
      if (s.getAttribute('data-sold') === '1') { return; }
      state[sizeIdx] = s.getAttribute('data-lmfp-size');
      if (errEl) { errEl.classList.remove('is-on'); }
      paint();
      return;
    }
    if (e.target.closest('[data-lmfp-sg]')) {
      if (sgEl) { sgEl.classList.toggle('is-open'); }
      return;
    }
    var cbc = e.target.closest('[data-lmfp-cbcol]');
    if (cbc) {
      var cardC = cbc.closest('[data-lmfp-combo]');
      var sc = cardC && cardC.lmState;
      if (!sc) { return; }
      sc.st[sc.ci] = cbc.getAttribute('data-lmfp-cbcol');
      if (sc.si > -1 && sc.st[sc.si] && !comboSizeAvail(cardC, sc.st[sc.si])) { sc.st[sc.si] = null; }
      paintCombo(cardC);
      return;
    }
    var cb = e.target.closest('[data-lmfp-cbsize]');
    if (cb) {
      if (cb.getAttribute('data-sold') === '1') { return; }
      var cardS = cb.closest('[data-lmfp-combo]');
      var ss = cardS && cardS.lmState;
      if (!ss) { return; }
      ss.st[ss.si] = cb.getAttribute('data-lmfp-cbsize');
      paintCombo(cardS);
      return;
    }
    var cba = e.target.closest('[data-lmfp-cbadd]');
    if (cba) { addCombo(cba); return; }
    var o = e.target.closest('[data-lmfp-open]');
    if (o) { openLb(parseInt(o.getAttribute('data-lmfp-open'), 10)); }
  });

  var toast = document.getElementById('lmfp-toast');
  var toastN = document.getElementById('lmfp-toast-n');
  var toastT = null;
  function showToast(txt) {
    if (!toast) { return; }
    if (toastN) { toastN.textContent = txt || ''; }
    toast.classList.add('is-on');
    if (toastT) { clearTimeout(toastT); }
    toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 3600);
  }

  /* Cartes « Completez la tenue » : coloris, taille, photo et prix suivent le choix. */
  function comboMatch(card) {
    var s = card.lmState;
    if (!s) { return null; }
    return s.cd.variants.filter(function (v) {
      for (var i = 0; i < s.st.length; i++) {
        if (s.st[i] !== null && s.st[i] !== undefined && v.opts[i] !== s.st[i]) { return false; }
      }
      return true;
    })[0] || null;
  }
  function comboSizeAvail(card, val) {
    var s = card.lmState;
    return s.cd.variants.some(function (v) {
      if (v.opts[s.si] !== val) { return false; }
      if (s.ci > -1 && v.opts[s.ci] !== s.st[s.ci]) { return false; }
      return v.available;
    });
  }
  function paintCombo(card) {
    var s = card.lmState;
    if (!s) { return; }
    if (s.ci > -1) {
      card.querySelectorAll('[data-lmfp-cbcol]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-lmfp-cbcol') === s.st[s.ci] ? 'true' : 'false');
      });
      var nm = card.querySelector('[data-lmfp-cbcolname]');
      if (nm) { nm.textContent = s.st[s.ci] || ''; }
    }
    if (s.si > -1) {
      card.querySelectorAll('[data-lmfp-cbsize]').forEach(function (b) {
        var val = b.getAttribute('data-lmfp-cbsize');
        b.setAttribute('data-sold', comboSizeAvail(card, val) ? '0' : '1');
        b.setAttribute('aria-pressed', val === s.st[s.si] ? 'true' : 'false');
      });
      var sn = card.querySelector('[data-lmfp-cbsizename]');
      if (sn) { sn.textContent = s.st[s.si] || s.pick; }
    }
    var v = comboMatch(card);
    if (v) {
      var im = card.querySelector('.lmfp-combo__i img');
      if (im && v.img && im.getAttribute('src') !== v.img) {
        im.setAttribute('src', v.img);
        im.removeAttribute('srcset');
      }
      var pr = card.querySelector('.lmfp-combo__p');
      if (pr) { pr.innerHTML = v.price; }
    }
  }
  root.querySelectorAll('[data-lmfp-combo]').forEach(function (card) {
    var el = card.querySelector('[data-lmfp-cbdata]');
    if (!el) { return; }
    var cd;
    try { cd = JSON.parse(el.textContent); } catch (e) { return; }
    if (!cd.variants || !cd.variants.length) { return; }
    var base = cd.variants.filter(function (v) { return v.available; })[0] || cd.variants[0];
    var sn = card.querySelector('[data-lmfp-cbsizename]');
    card.lmState = {
      cd: cd,
      ci: cd.colPos > 0 ? cd.colPos - 1 : -1,
      si: cd.sizePos > 0 ? cd.sizePos - 1 : -1,
      st: base.opts.slice(),
      pick: sn ? sn.textContent : ''
    };
    if (card.lmState.si > -1) { card.lmState.st[card.lmState.si] = null; }
    paintCombo(card);
  });

  function addCombo(btn) {
    var card = btn.closest('[data-lmfp-combo]');
    if (!card || !card.lmState) { return; }
    var s = card.lmState;
    if (s.si > -1 && !s.st[s.si]) {
      card.querySelectorAll('[data-lmfp-cbsize][data-sold="0"]').forEach(function (x) {
        x.style.borderColor = '#9B2C2C';
        setTimeout(function () { x.style.borderColor = ''; }, 1200);
      });
      return;
    }
    var v = comboMatch(card);
    if (!v || !v.available) { return; }
    var label = btn.textContent;
    var nameEl = card.querySelector('.lmfp-combo__n');
    var name = nameEl ? nameEl.textContent.trim() : '';
    var bits = [];
    if (s.ci > -1 && s.st[s.ci]) { bits.push(s.st[s.ci]); }
    if (s.si > -1 && s.st[s.si]) { bits.push('taille ' + s.st[s.si]); }
    btn.disabled = true;
    window.__lmNoDrawer = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function () {
      btn.disabled = false;
      btn.classList.add('is-done');
      btn.textContent = 'Ajouté';
      showToast(bits.length ? name + ' · ' + bits.join(' · ') : name);
      setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 2200);
    }).catch(function () { btn.disabled = false; window.__lmNoDrawer = false; });
  }

  /* paiement accelere : tant qu'aucune taille n'est choisie, on renvoie sur le message d'erreur */
  if (accel) {
    accel.addEventListener('click', function (e) {
      if (!accel.classList.contains('is-locked')) { return; }
      e.preventDefault();
      e.stopPropagation();
      if (errEl) { errEl.classList.add('is-on'); }
      var sz = document.getElementById('lmfp-sz');
      if (sz) { sz.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }, true);
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (sizeIdx > -1 && !state[sizeIdx]) {
        if (errEl) { errEl.classList.add('is-on'); }
        return;
      }
      var v = match();
      if (!v || !v.available) { return; }
      addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      }).then(function () {
        addBtn.disabled = false;
      }).catch(function () {
        addBtn.disabled = false;
      });
    });
  }

  /* la hauteur du carrousel suit la photo affichee : aucune bande grise */
  function fitGal() {
    if (!gal || !isMobile()) { return; }
    var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
    var cell = gal.children[i];
    if (!cell) { return; }
    var btn = cell.querySelector('.lmfp-gal__i');
    if (!btn) { return; }
    var ar = btn.style.getPropertyValue('--ar');
    if (!ar || ar.indexOf('/') === -1) { return; }
    var parts = ar.split('/');
    var w = parseFloat(parts[0]);
    var hh = parseFloat(parts[1]);
    if (!w || !hh) { return; }
    gal.style.height = Math.round(gal.clientWidth * hh / w) + 'px';
  }
  window.addEventListener('resize', function () {
    if (gal && !isMobile()) { gal.style.height = ''; } else { fitGal(); }
  });

  /* galerie mobile : puces et compteur */
  function onScroll() {
    fitGal();
    if (!gal || (!dots && !count)) { return; }
    var i = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth));
    if (dots) {
      var kids = dots.children;
      for (var k = 0; k < kids.length; k++) { kids[k].className = k === i ? 'is-on' : ''; }
    }
    if (count) { count.firstElementChild.textContent = String(i + 1); }
  }
  if (gal) {
    var t = null;
    gal.addEventListener('scroll', function () {
      if (t) { return; }
      t = setTimeout(function () { t = null; onScroll(); }, 90);
    }, { passive: true });
    gal.addEventListener('scrollend', onScroll, { passive: true });
    gal.addEventListener('touchend', function () { setTimeout(onScroll, 160); }, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var n = 0; n < entries.length; n++) {
          if (entries[n].isIntersecting && entries[n].intersectionRatio > 0.6) { onScroll(); break; }
        }
      }, { root: gal, threshold: [0.61] });
      for (var c2 = 0; c2 < gal.children.length; c2++) { io.observe(gal.children[c2]); }
    }
  }

  /* visionneuse */
  var lb = document.getElementById('lmfp-lb');
  var lbImg = document.getElementById('lmfp-lbimg');
  var lbC = document.getElementById('lmfp-lbc');
  var cursor = 0;

  function showLb() {
    var m = data.media[cursor];
    if (!m) { return; }
    lbImg.src = m.src;
    lbImg.alt = m.alt || '';
    if (lbC) { lbC.textContent = (cursor + 1) + ' / ' + data.media.length; }
  }
  function openLb(i) {
    if (!lb || !data.media.length) { return; }
    cursor = i || 0;
    showLb();
    lb.classList.add('is-open');
    document.body.classList.add('lmfp-locked');
  }
  function closeLb() {
    if (!lb) { return; }
    lb.classList.remove('is-open');
    document.body.classList.remove('lmfp-locked');
  }
  function stepLb(d) {
    cursor = (cursor + d + data.media.length) % data.media.length;
    showLb();
  }
  if (lb) {
    lb.addEventListener('click', function (e) {
      if (e.target.closest('[data-lmfp-lbclose]')) { closeLb(); return; }
      var st = e.target.closest('[data-lmfp-lbstep]');
      if (st) { stepLb(parseInt(st.getAttribute('data-lmfp-lbstep'), 10)); return; }
      if (e.target === lb) { closeLb(); }
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) { return; }
      if (e.key === 'Escape') { closeLb(); }
      if (e.key === 'ArrowLeft') { stepLb(-1); }
      if (e.key === 'ArrowRight') { stepLb(1); }
    });
  }

  paint();
  fitGal();
}());
